import { convertDateToTimeZone } from '../../../../../utils/convertDateToTimeZone';

// We want to return true (for Open) or false (for Closed) based on these string formats: "Mo-Su 08:30-17:00" / "Mo-Fr 04:30-20:30;  Su 04:30-20:30; Sa 04:30-19:30"
export function isPoiOpen(hoursString?: string) {
	if (!hoursString) return false;

	const daysMap = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

	const now = convertDateToTimeZone(new Date());
	const currentDayIndex = now.getDay() === 0 ? 6 : now.getDay() - 1; // Map Sunday (0) to Su (index 6)
	const currentTime = now.toTimeString().slice(0, 5); // Format HH:mm

	// Split the string into individual day-time ranges
	const ranges = hoursString.split(';').map((range) => range.trim());

	return ranges.some((range) => {
		const [dayPart, timePart] = range.split(' ');
		const [startTime, endTime] = timePart.split('-');

		// Split the day part into multiple day ranges (Ex. Mo-Su or single days like Tu)
		const dayRanges = dayPart.split(',');

		return dayRanges.some((dayRange) => {
			const [startDay, endDay] = dayRange.split('-');

			const startDayIndex = daysMap.indexOf(startDay);
			const endDayIndex = endDay ? daysMap.indexOf(endDay) : startDayIndex;

			const isWithinDayRange =
				startDayIndex <= endDayIndex
					? currentDayIndex >= startDayIndex && currentDayIndex <= endDayIndex
					: currentDayIndex >= startDayIndex || currentDayIndex <= endDayIndex;

			const isWithinTimeRange =
				currentTime >= startTime && currentTime <= endTime;

			return isWithinDayRange && isWithinTimeRange;
		});
	});
}
